import { render } from "./DesignSimulation.vue?vue&type=template&id=a38a74f6"
import script from "./DesignSimulation.vue?vue&type=script&lang=js"
export * from "./DesignSimulation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__